import { DateTime } from 'luxon';

const prepareArticleRequest = async (values) => {
  const {
    status, title, url, shortDescription, content,
    marketplace, brand, theme, carMake, carModel, carYear,
    category, previewImage, bannerImage, metaTitle,
    metaDescription, relatedItem, articleCars
  } = values;

  return {
    article_status: status?.value,
    article_title: title,
    article_meta_title: metaTitle,
    article_url: url,
    article_slug: url,
    article_short_description: shortDescription,
    article_meta_description: metaDescription,
    article_html: content,
    article_marketplace_name: marketplace?.value,
    article_brand: brand.map(({ value }) => value),
    article_section: theme.map(({ value }) => value),
    article_car_make: carMake?.value,
    article_car_model: carModel?.value,
    article_car_years: carYear?.map(({ value }) => value),
    article_categories: category,
    article_main_image: bannerImage,
    article_main_preview: previewImage,
    article_last_edite: DateTime.local().setLocale('en').toFormat('yyyy-LL-dd HH:mm:ss'),
    article_related_items: relatedItem?.map(({ listing_id: id }) => id),
    article_cars: articleCars
  };
};
export default prepareArticleRequest;
